import { district } from '../../../schema';
import { denormalize } from 'normalizr';

export const selectHydrated = (state, id) => denormalize(id, district, state.entities);

export const selectDisctrictOptions = (state) => {
  const districts = state.entities.districts;

  return Object.keys(districts).map(k => ({
    id: k,
    label: districts[k].name
  }))
};


// WEBPACK FOOTER //
// ./src/redux/modules/districts/selectors.js